import { EnvironmentDefinition } from "./environment-definition";

export class Environments {
    public static environments: EnvironmentDefinition[] = [
       {
        name : 'local',
        // apiUrl : 'https://worldofwebinar-api.azurewebsites.net/',
        apiUrl : 'https://localhost:44367', //'https://localhost:5001'
        host : ['localhost']
       },
       {
        name : 'DEV',
        apiUrl : 'https://worldofwebinar-api.azurewebsites.net/',
        host : ['worldofwebinar-dev.azurewebsites.net']
       },
       {
        name : 'qa',
        apiUrl : 'https://worldofwebinarqa-api-e9eae6czhqf6h7c3.centralus-01.azurewebsites.net/',
        host : ['worldofwebinar-qa-geh8acb2bgdsbxgh.centralus-01.azurewebsites.net']
       },
       {
        name : 'prod',
        apiUrl : 'https://worldofwebinars-prod-api-awedbkdabvdmhvfw.centralus-01.azurewebsites.net/',
        host : ['lootlucky.com']
       }

    ]
}
